<template>
  <div class="footer">
    <div class="wrap">
      <div class="info-area">
        <div class="item">
          <div class="title">{{ foot.about_us.title }}</div>
          <div class="info ab">
            {{ foot.about_us.content }}
          </div>
        </div>
        <div class="item phone">
          <div class="title">联系方式</div>
          <div class="info">
            <div>电话： {{ foot.link_type.phone }}</div>
            <div>邮箱：{{ foot.link_type.email }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright">
     {{ foot.foot_setting.content }}
    </div>
  </div>
</template>

<script>
import { setting } from "../network/http_api";
export default {
  data() {
    return {
      foot: {
        about_us:{
          title:'',
          content:''
        },
        link_type:{
          phone:'',
          email:''
        },
        foot_setting:{
          content:''
        }
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await setting();
      if (res.code == 200) {
        this.foot = JSON.parse(res.data.page_setting);
        //console.log("footres", res);
      } else {
        this.$message.error(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  height: 320px;
  color: #ffffff;
  background: #262626;
  overflow: hidden;
  .wrap {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .info-area {
      display: flex;
      .item {
        width: 368px;
        margin-top: 40px;
        margin-right: 232px;
        .title {
          font-size: 18px;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 14px;
        }
        .info {
          font-size: 12px;
          color: #ffffff;
          line-height: 18px;
          opacity: .7;
          
        }
        .ab {
            line-height: 20px;
          letter-spacing: 4px;
        }
      }
      .phone {
        .info {
          font-size: 14px;
          color: #ffffff;
          div {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .copyright {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 18px;
    width: 1200px;
    color: #fff;
    text-align: center;
    margin-bottom: 18px;
  }
}
</style>